<template>
  <div ref="listbox" class="list1" :style="style">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    style: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.setScroll()
  },
  methods: {
    setScroll() {
      const el = this.$refs.listbox
      el.addEventListener('scroll', () => {
        const isScroll = el.scrollTop + el.offsetHeight >= el.scrollHeight
        if (isScroll) {
          this.$emit('on-scroll', el)
        }
      })
    }
  }
}
</script>

<style scoped>
.list1 {
  overflow-y: auto;
}
</style>
